<script setup lang="ts">
import KycSessionLayout from '@/layout/KycSessionLayout.vue';
import sadFace from '@/assets/icons/face-sad-cry-regular.svg';

function reload() {
  window.location.reload();
}
import SupportLinks from '@/components/session/kyc/supportLinks/SupportLinks.vue';
</script>

<template>
  <KycSessionLayout>
    <div class="my-12 flex flex-col px-4" data-test="screen-kyc-error">
      <img :src="sadFace" class="mb-3 size-16" />
      <h1 class="mb-4 text-3xl">Something went wrong</h1>
      <p class="text-light-secondary dark:text-dark-secondary mb-8">
        We are unable to continue this time.
      </p>

      <p class="text-light-secondary dark:text-dark-secondary mb-16">
        <SupportLinks issue="kyc-timeout" />
      </p>
      <div
        class="border-light-border dark:border-dark-semi-transparent fixed bottom-0 left-0 mt-2 w-full border-t p-4 sm:relative sm:border-none sm:bg-inherit sm:p-0"
      >
        <button
          @click.stop="reload"
          class="border-light-border bg-light-primary text-dark-primary outline-light-border dark:border-dark-brd-dark dark:bg-dark-item dark:outline-dark-brd-dark mx-auto my-2 w-full rounded-full border py-3 outline-2"
          data-test="reload-page"
        >
          Try Again
        </button>
      </div>
    </div>
  </KycSessionLayout>
</template>
